import type React from 'react';

const QuoteGeneration: React.FC = () => {
  return <div>Quote Generation Component</div>;
};

export default QuoteGeneration;
